// mds-dojo — FAITHFUL port of dojox/widget/_CalendarDay (dojo 1.x). declare from declare-runtime;
// dojo/text!./Calendar/X.html → import ?raw. Upgrades the earlier deliberate STUB to a full port.
import declare from '../../dojo/_base/declare-runtime';
import _CalendarDayView from './_CalendarDayView';
export default declare("dojox.widget._CalendarDay", null, {
		// summary:
		//		Mixin for the dojox.widget.Calendar which provides
		//		the standard day-view. A single month is shown at a time.
		parent: null,

		constructor: function(){
			this._addView(_CalendarDayView);
		}
	});
